module.exports = __webpack_public_path__ + "img/copybook_active.7bc257b1.png";